import React, { useEffect, useState } from "react";
import { collection, getDocs, where, query } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const useGetOrders = (userId) => {
  const [myOrders, setMyOrders] = useState([]);

  const gettingOrders = async () => {
    const orders = [];
    // const querySnapshot = await getDocs(collection(db, "orders"));
    const q = query(collection(db, "orders"), where("contactId", "==", userId));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // console.log(doc.data())
      orders.push({ ...doc.data(), id: doc.id });
    });
    setMyOrders(orders);
  };

  useEffect(() => {
    gettingOrders();
  }, [userId]);

  return { myOrders };
};

export default useGetOrders;
